import React from "react";
import { Element } from "@craftjs/core";
import { Container } from "../../components/user/Container";
import { Text } from "../../components/user/Text";
import { Image } from "../../components/user/Image";
import { ResponsiveContainer } from "../../components/user/ResponsiveContainer";

export const TestimonialsSection = () => {
  // Testimonial data for better readability and management
  const testimonials = [
    {
      id: 1,
      text: "This gaming subscription is amazing! I've discovered so many new games I wouldn't have tried otherwise. Definitely worth every euro!",
      name: "Laura K.",
      role: "Mobile Gamer",
      avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    },
    {
      id: 2,
      text: "I've been a member for 3 months and the game selection is constantly refreshed with new titles. The subscription pays for itself with the amount of gaming I do!",
      name: "Matas J.",
      role: "Gaming Enthusiast",
      avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      id: 3,
      text: "The variety of games available is impressive. From indie titles to major releases, there's something for everyone. Customer support is also excellent!",
      name: "Sophia R.",
      role: "Casual Gamer",
      avatar: "https://randomuser.me/api/portraits/women/68.jpg",
    },
  ];

  return (
    <Element
      id="testimonials_section_container"
      canvas
      is={Container}
      className="testimonials-section"
      padding="80px 20px"
      background="#f8fafc"
      margin="0"
      borderRadius={0}
      width="100%"
      height="auto"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Text
        text="What Our Gamers Say"
        fontSize={42}
        color="#1a1a2e"
        fontWeight="bold"
        textAlign="center"
        margin="0 0 50px 0"
        padding="0"
      />

      <Element
        id="testimonials_grid_container"
        canvas
        is={ResponsiveContainer}
        className="testimonials-container"
        background="transparent"
        padding="0"
        margin="0 auto"
        borderRadius={0}
        gap="50px"
        // Mobile styles
        mobileStyles={{
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          gap: "40px",
        }}
        // Tablet styles
        tabletStyles={{
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          gap: "40px",
        }}
        // Laptop styles
        laptopStyles={{
          flexDirection: "row",
          alignItems: "stretch",
          justifyContent: "space-between",
          width: "100%",
          gap: "40px",
        }}
        // Desktop styles
        desktopStyles={{
          flexDirection: "row",
          alignItems: "stretch",
          justifyContent: "space-between",
          width: "100%",
          gap: "50px",
        }}
      >
        {testimonials.map((testimonial) => (
          <Element
            key={`testimonial_card_${testimonial.id}`}
            id={`testimonial_card_${testimonial.id}`}
            canvas
            is={Container}
            className="testimonial-card"
            padding="30px"
            margin="0 0 20px 0"
            borderRadius={10}
            width="100%"
            height="auto"
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-start"
            background="#ffffff"
            boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
          >
            <Image
              src={testimonial.avatar}
              width="80px"
              height="80px"
              margin="0 0 20px 0"
              padding="0"
              borderRadius={50}
            />
            <Text
              text="⭐⭐⭐⭐⭐"
              fontSize={24}
              color="#fbbf24"
              fontWeight="normal"
              textAlign="center"
              margin="0 0 15px 0"
              padding="0"
            />
            <Text
              text={testimonial.text}
              fontSize={16}
              color="#4b5563"
              fontWeight="normal"
              textAlign="center"
              margin="0 0 20px 0"
              padding="0"
            />
            <Text
              text={testimonial.name}
              fontSize={18}
              color="#000000"
              fontWeight="bold"
              textAlign="center"
              margin="0 0 5px 0"
              padding="0"
            />
            <Text
              text={testimonial.role}
              fontSize={14}
              color="#6b7280"
              fontWeight="normal"
              textAlign="center"
              margin="0"
              padding="0"
            />
          </Element>
        ))}
      </Element>
    </Element>
  );
};
